import type {CSSProperties, ReactNode} from 'react';
import cx from 'classnames';
import styles from './highlight-box.module.scss';

export type HighlightBoxProps = {
  backgroundColor: string;
  textColor?: string;
  children: ReactNode;
  className?: string;
};

const HighlightBox = ({backgroundColor, textColor, children, className}: HighlightBoxProps) => {
  const style: CSSProperties = {
    backgroundColor,
    ...(textColor ? {color: textColor} : {})
  };

  return (
    <div className={cx(styles.box, className)} style={style}>
      <div className={styles.inner}>{children}</div>
    </div>
  );
};

export default HighlightBox;
